/*
 * cart-bar.js — Free-shipping progress bar + favicon notification badge
 * For Shopify Dawn-derived themes. No dependencies, no theme-internal imports.
 *
 * WIRING (see chat for the two small Liquid edits):
 *   1) Upload this file to your theme's /assets folder.
 *   2) In layout/theme.liquid, right before </body>:
 *        <script src="{{ 'cart-bar.js' | asset_url }}" defer="defer"></script>
 *   3) Mark ONE announcement slide as the dynamic one (sentinel edit in chat).
 *
 * CONFIG: override any default by defining window.cartBarConfig BEFORE this
 * script loads, e.g. in theme.liquid <head>:
 *   <script>window.cartBarConfig = { threshold: 8500 };</script>
 */
(function () {
  'use strict';

  var defaults = {
    threshold: 5000,                                   // free-shipping minimum, in CENTS ($50.00)
    currencySymbol: '$',
    progressMessage: 'Only {{remaining}} away from free shipping.',
    successMessage: "Congratulations, You've got free shipping.",
    faviconBlink: true,
    blinkIntervalMs: 2000                              // 2s badge ON / 2s OFF
  };
  var config = Object.assign({}, defaults, window.cartBarConfig || {});

  /* ---------------------------------------------------------------------- *
   * Shared cart state                                                      *
   * ---------------------------------------------------------------------- */
  var cart = { item_count: 0, total_price: 0 };
  var listeners = [];
  function onCartChange(fn) { listeners.push(fn); fn(cart); }
  function emit() {
    for (var i = 0; i < listeners.length; i++) {
      try { listeners[i](cart); } catch (e) {}
    }
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart.js';
  }

  function refreshCart() {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cart.item_count = data.item_count || 0;
        cart.total_price = data.total_price || 0;   // post line-item-discount total, in cents
        emit();
        return cart;
      })
      .catch(function () {});
  }

  // Catch every cart mutation Dawn (or an installed app) makes, then re-sync.
  // Dawn routes all cart ops through fetch -> /cart/add|change|update|clear.
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var input = arguments[0];
        var url = (input && input.url) ? input.url : String(input);
        if (/\/cart\/(add|change|update|clear)/i.test(url)) {
          p.then(function () { setTimeout(refreshCart, 50); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  // Belt-and-suspenders: also listen to Dawn's own pub/sub event if present.
  function hookPubSub() {
    if (typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshCart(); });
    }
  }

  /* ---------------------------------------------------------------------- *
   * Feature 1: free-shipping progress message                             *
   * ---------------------------------------------------------------------- */
  var saleTextCache = null;

function formatMoney(cents) {
    return config.currencySymbol + (cents / 100).toFixed(2);
  }

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Wrap any $12.34 / $1,200.00 style amount in a styleable span.
  function wrapPrices(text) {
    return escapeHtml(text).replace(
      /(\$[\d,]+(?:\.\d{2})?)/g,
      '<span class="free-shipping-amount">$1</span>'
    );
  }

  function updateShippingBar(state) {
    var el = document.querySelector('[data-free-shipping-bar]');
    if (!el) return;

    if (saleTextCache === null) {
      saleTextCache = (el.getAttribute('data-sale-text') || el.textContent || '').trim();
    }

    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || config.threshold;
    var html;

    if (state.item_count === 0) {
      html = wrapPrices(saleTextCache);                                   // sale + goal
    } else if (state.total_price >= threshold) {
      html = escapeHtml(config.successMessage);                          // qualified
    } else {
      var remaining = threshold - state.total_price;
      html = escapeHtml(config.progressMessage).replace('{{remaining}}', function () {
        return '<span class="free-shipping-amount">' + formatMoney(remaining) + '</span>';
      });
    }
    el.innerHTML = html;
  }

  /* ---------------------------------------------------------------------- *
   * Feature 2: blinking favicon badge while tab is unfocused + cart > 0    *
   * ---------------------------------------------------------------------- */
  var Favicon = (function () {
    var originalHref = null, badgedHref = null;
    var built = false, building = false;
    var timer = null, phaseBadge = false, wantBlink = false;

    function readOriginal() {
      var l = document.querySelector('link[rel~="icon"]');
      return l ? l.href : (location.origin + '/favicon.ico');
    }

    function setIcon(href) {
      if (!href) return;
      var links = document.querySelectorAll('link[rel~="icon"]');
      for (var i = 0; i < links.length; i++) {
        if (links[i].parentNode) links[i].parentNode.removeChild(links[i]);
      }
      var link = document.createElement('link');
      link.setAttribute('rel', 'icon');
      link.setAttribute('href', href);
      document.head.appendChild(link);
    }

    // Composite the "1" badge onto the existing favicon. crossOrigin=anonymous
    // means: if the CDN sends CORS headers we get the branded icon + badge;
    // if not, the load fails cleanly and we draw a badge-only icon (no taint,
    // toDataURL always succeeds).
    function build(done) {
      if (built) { done(); return; }
      if (building) return;
      building = true;

      var size = 64;
      var canvas = document.createElement('canvas');
      canvas.width = canvas.height = size;
      var ctx = canvas.getContext('2d');

      function drawBadge() {
        var r = size * 0.34, cx = size - r - 2, cy = r + 2;
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
        ctx.fillStyle = '#e02b2b';
        ctx.fill();
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold ' + Math.round(r * 1.5) + 'px Arial, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('1', cx, cy + 1);
        try { badgedHref = canvas.toDataURL('image/png'); } catch (e) { badgedHref = null; }
        built = true; building = false; done();
      }

      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try { ctx.drawImage(img, 0, 0, size, size); } catch (e) {}
        drawBadge();
      };
      img.onerror = drawBadge;
      img.src = originalHref;
    }

    function begin() {
      if (!wantBlink || timer) return;
      phaseBadge = true;
      setIcon(badgedHref || originalHref);
      timer = setInterval(function () {
        if (!wantBlink) return;
        phaseBadge = !phaseBadge;
        setIcon(phaseBadge && badgedHref ? badgedHref : originalHref);
      }, config.blinkIntervalMs);
    }

    function start() {
      wantBlink = true;
      if (originalHref === null) originalHref = readOriginal();
      if (timer) return;
      if (built) begin(); else build(begin);
    }

    function stop() {
      wantBlink = false;
      if (timer) { clearInterval(timer); timer = null; }
      setIcon(originalHref);
      phaseBadge = false;
    }

    return { start: start, stop: stop };
  })();

  function evaluateFavicon() {
    if (!config.faviconBlink) return;
    var unfocused = document.hidden || !document.hasFocus();
    if (cart.item_count > 0 && unfocused) Favicon.start();
    else Favicon.stop();
  }

  /* ---------------------------------------------------------------------- *
   * Boot                                                                   *
   * ---------------------------------------------------------------------- */
  function init() {
    hookPubSub();
    onCartChange(updateShippingBar);
    onCartChange(evaluateFavicon);
    document.addEventListener('visibilitychange', evaluateFavicon);
    window.addEventListener('blur', evaluateFavicon);
    window.addEventListener('focus', evaluateFavicon);
    refreshCart();   // initial state on page load
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();